import { Stack, Typography } from '@mui/material';
import { MUITable } from 'components/shared/MUITable';
import { SmartIntakeHistoryRow } from './SmartIntakeTypes';
import { createSmartIntakeHistoryTableColumns } from './SmartIntakeHistoryTableConfig';

interface Props {
  rows: SmartIntakeHistoryRow[];
  isLoading: boolean;
  emptyMessage: string;
  onViewDetails: (row: SmartIntakeHistoryRow) => void;
}

export const SmartIntakeHistoryTable = ({ rows, isLoading, emptyMessage, onViewDetails }: Props) => {
  const columns = createSmartIntakeHistoryTableColumns({ onViewDetails });

  if (!isLoading && !rows.length) {
    return (
      <Typography color="text.secondary" sx={{ mt: 2 }}>
        {emptyMessage}
      </Typography>
    );
  }

  return (
    <Stack flex={1} overflow="hidden">
      <MUITable<SmartIntakeHistoryRow> stickyHeader hover isLoading={isLoading} tableData={rows} columns={columns} />
    </Stack>
  );
};
